import { render } from "./RevenueStats.vue?vue&type=template&id=3b8124c5"
import script from "./RevenueStats.vue?vue&type=script&lang=js"
export * from "./RevenueStats.vue?vue&type=script&lang=js"

import "./RevenueStats.vue?vue&type=style&index=0&id=3b8124c5&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__